import {
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { SupportedLocale } from "@/i18n";
import { ACCORDION_TITLE_CLASS } from "@/lib/accordion-content";

interface CreditsAccordionProps {
  creditOeuvres: string;
  creditPhotoOeuvres: string;
  creditRemarques?: string;
  locale: SupportedLocale;
  t: (key: string) => string;
}

export function CreditsAccordion({
  creditOeuvres,
  creditPhotoOeuvres,
  creditRemarques,
  locale: _locale,
  t,
}: CreditsAccordionProps) {
  const oeuvre = creditOeuvres?.trim() ?? "";
  const photo = creditPhotoOeuvres?.trim() ?? "";
  const remarques = creditRemarques?.trim() ?? "";
  const creditLine = [oeuvre, photo].filter(Boolean).join(" | ");

  if (!creditLine && !remarques) return null;

  return (
    <AccordionItem value="credits">
      <AccordionTrigger className={ACCORDION_TITLE_CLASS}>
        {t("singleArtworkSubtitleCredits")}
      </AccordionTrigger>
      <AccordionContent className="flex flex-col gap-2">
        {creditLine ? <p>{creditLine}</p> : null}
        {remarques ? (
          <div dangerouslySetInnerHTML={{ __html: remarques }} />
        ) : null}
      </AccordionContent>
    </AccordionItem>
  );
}
